import React, {Component} from 'react';
import { ConnectedRouter } from 'react-router-redux';
import ProtectedRouter from './protectedRouter';
import history from '../config/history';
import { connect } from 'react-redux';
import { ACTIONS } from '../actions/actionTypes';

class RouterContainer extends Component {
    componentDidMount () {
        this.props.appStarted();
    }

    render () {
        return (
            <ConnectedRouter history={history}>
                <ProtectedRouter />
            </ConnectedRouter>
        );
    }
};

const mapState = () => {
    return {};
};

const mapDispatch = (dispatch) => ({
    appStarted: () => dispatch({type: ACTIONS.S_APP_STARTED})
});

export default connect(mapState, mapDispatch)(RouterContainer);



// WEBPACK FOOTER //
// ./src/routes/router.js